import { DropDetails } from 'components/well/constants';
import { OverlayTools } from '../constants';
import { usePoiCreateHandlers } from './poi';
import { useRoiCreateHandlers } from './roi';
import { useRulerCreateHandlers } from './ruler';
import { useScribbleCreateHandlers } from './scribble';
import { useAnnotationCreateHandlers } from './annotation';
import { useDrawingColor } from 'redux/hooks/well';
import { getColorNumbersString } from '../utils';
import TransformPoints from 'components/plateviewer/well/TransformPoints';
import { WellDetailsStates } from 'business/models/CustomModels';
import useCrystalCreateHandler from './crystal';
import { useDropLocationCreateHandlers } from './dropLocation';

export const useDrawingCreationHandlers = (
  drawingTool: OverlayTools,
  wellDetails: DropDetails | WellDetailsStates,
  regionName: string,
  tpObject: TransformPoints,
  onCloseAnnotationModal?: () => void,
  getCrystalName?: (index: number) => string,
) => {
  const drawingColor = getColorNumbersString(useDrawingColor());
  const poiHandlers = usePoiCreateHandlers(wellDetails, regionName, tpObject);
  const roiHandlers = useRoiCreateHandlers(wellDetails, regionName, tpObject);
  const rulerHandlers = useRulerCreateHandlers(drawingColor, tpObject);
  const annotationHandlers = useAnnotationCreateHandlers(
    tpObject,
    onCloseAnnotationModal,
  );
  const scribbleHandlers = useScribbleCreateHandlers(drawingColor, tpObject);
  const crystalHandlers = useCrystalCreateHandler(
    wellDetails,
    regionName,
    tpObject,
    getCrystalName,
  );
  const dropLocationHandler = useDropLocationCreateHandlers(tpObject);
  switch (drawingTool) {
    case OverlayTools.POI:
      return poiHandlers;
    case OverlayTools.ROI:
      return roiHandlers;
    case OverlayTools.RULER:
      return rulerHandlers;
    case OverlayTools.ANNOTATION:
      return annotationHandlers;
    case OverlayTools.SCRIBBLE:
      return scribbleHandlers;
    case OverlayTools.CRYSTAL:
      return crystalHandlers;
    case OverlayTools.DROPLOCATION:
      return dropLocationHandler;
  }
};
